<template>
  <div class="layout-notice-card">
    <div class="user-header" ref="userHeader">
      <div class="avatar-row">
        <div class="user-avatar">
          <img v-show="!!avatar"
                :src="avatar">
          <i v-show="!avatar"
              class="layout layout-user"></i>
        </div>
        <div class="name">Hi~ {{userName}}</div>
      </div>
      <div class="user-slogan user-slogan-two-line" v-html="slogan"></div>
      <div class="time"><span style="margin-right:20px">{{currentDate}}</span><span>{{currentDay}}</span></div>
    </div>
    <div id="notice-list-box" v-show="showNoticeList"></div>
    <!-- <BssHomeNoticeList /> -->
  </div>
</template>

<script>
  import moment from 'moment'
  import mixins from 'public/mixins'
  import hideImg from './images/hide-eye.svg'
  import showImg from './images/show-eye.svg'
  import ziBg from './images/zi-bg.png'
  import lanBg from './images/lan-bg.png'
  import huiBg from './images/hui-bg.png'
  import lvBg from './images/lv-bg.png'
  import hongBg from './images/hong-bg.png'
  // import BssHomeNoticeList from '@/ams/pages/home-notice/notice-list.vue'
  const THEME_IMG_MAP = {
    '#894fd5': ziBg, // 紫色
    '#2a67e6': lanBg, // 蓝色
    '#0fc26d': lvBg, // 绿色
    '#f74c4c': hongBg, // 红色
    '#3d495a': huiBg, // 灰色
  }

  export default {
    // components: {BssHomeNoticeList},
    mixins: [mixins],
    data () {
      return {
        currentDate: moment().format('YYYY-MM-DD'),
        currentDay: moment().format('dddd'),
        hideImg,
        showImg,
        visible: true,
        list: [],
        slogan: '',
        unReadNum: 0,
        themeColor: '#894fd5'
      }
    },
    computed: {
      user () {
        return this.$store.getters.user
      },
      avatar () {
        return this.$store.state.avatar
      },
      userName () {
        return (this.user.name || '').replace(/[0-9]/ig, '')
      },
      showNoticeList () {
        const list = this.lookUpOptions['sys_layout_home_notice_list_white_user'] || []
        const isNew = list.find(item => item.value === 'new')
        if (isNew) {
          return true
        }
        const employeeNumber = this.user.employeeNumber
        return !!list.find(item => item.value === employeeNumber)
      },
    },
    created () {
      this.noticeList = null
    },
    watch: {
      showNoticeList () {
        this.initListComp()
      }
    },
    mounted () {
      this.$bus.$on('SET_THEME', theme => {
        if (theme) {
          this.initBg(theme.header)
        }
      })
    },
    // 防止其他页面刷新导致数据丢失
    activated () {
      // this.$bus.$once('OA_NOTICE_TO_HOME', this.getNoticeList)
      this.init()
    },
    methods: {
      init () {
        this.initBg()
        this.initSlogan()
        this.initDate()
        this.initListComp()
      },
      initDate () {
        this.currentDate = moment().format('YYYY-MM-DD')
        this.currentDay = moment().format('dddd')
      },
      // 获取人文关怀文案
      async initSlogan() {
        const {list = []} = await this.$http('kuasheng.ksApplicationAdv.getErpHomePageCareReminder', {}, {appkey: '10184'})
        if (list.length) {
          const index = Math.floor(Math.random() * list.length)
          this.slogan = list[index].richName || list[index].name
        } else {
          this.slogan = ''
        }
      },
      // 获取未读消息数量
      async getNoticeNum () {
        try {
          this.unReadNum = await this.$http('kuasheng.newsNotification.newsNoReadNum', {}, {appkey: '10184'})
        } catch (err) {
          console.error(err)
        } finally {
          this.unReadLoading = false
        }
      },
      getBgImg (theme) {
        return THEME_IMG_MAP[theme]
      },
      getInitTheme () {
        const obj = JSON.parse(localStorage.ERPTHEME || '{}')
        return obj.header || '#894fd5'
      },
      initBg (theme) {
        if (!theme) theme = this.getInitTheme()
        const bg = this.getBgImg(theme)
        this.$refs.userHeader.style.backgroundImage = `url(${bg}) `
      },
      initListComp () {
        if (this.noticeList || !this.showNoticeList) {
          return
        }

        const noticeList = new Promise(window.__ERP_REMOTE_IMPORT__('sys/BssHomeNoticeList'))
        noticeList.then(res => {
          let Ctor = this.$options._base.extend(res.default)
          this.noticeList = new Ctor({ parent: this })
          this.noticeList.$mount('#notice-list-box')
        }).catch(console.log)
      },

    }
  }
</script>

<style lang="scss" scoped>
.layout-notice-card {
  width: 100%;
  min-height: 156px;
  border-radius: 4px;
  box-sizing: border-box;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  .user-header {
    height: 156px;
    border: 1px solid #ffffff;
    box-sizing: border-box;
    min-height: 156px;
    padding: 33px 16px 20px;
    border-radius: 4px;
    background-repeat:no-repeat;
    background-size: cover;
  }
  .avatar-row {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    .name {
      color: #333333;
      font-weight: 600;
      font-size: 16px;
    }
    .user-avatar {
      width: 34px;
      height: 34px;
      line-height: 34px;
      text-align: center;
      border-radius: 50%;
      background-color: #ffffff;
      margin-right: 8px;
      i {
        font-size: 34px;
        color: #4d26bf;
      }
      img {
        width: 34px;
        height: 34px;
        border-radius: 50%;
        display: block;
      }
    }
  }
  .user-slogan {
    line-height: 16px;
    color: #333333;
    font-weight: normal;
    margin: 10px 0 10px;
    font-size: 12px;
    font-weight: normal;
    padding-right: 100px;
    text-overflow: ellipsis;
    overflow: hidden;
    line-height: 14px;
  }
  .time {
    color: rgba(0, 0, 0, 0.5);
    font-size: 12px;
    line-height: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/pages/home/notice.vue